import { render, staticRenderFns } from "./RegisterDevice.vue?vue&type=template&id=0edaefa8&scoped=true"
import script from "./RegisterDevice.vue?vue&type=script&lang=js"
export * from "./RegisterDevice.vue?vue&type=script&lang=js"
import style0 from "./RegisterDevice.vue?vue&type=style&index=0&id=0edaefa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edaefa8",
  null
  
)

export default component.exports